module.exports = __webpack_public_path__ + "img/homescapes.772d2299.jpg";